import { AuthorizedUser } from './authorized-user.service';
import { StorageKeys } from '../../shared/models/storage-keys';
import { DEFAULT_DIALOG_CLASSES, ModalActions, MONIEPOINT_DESIGN_TYPE, UserAlias } from '../../shared/constants';
import { Injectable } from '@angular/core';
import { ApiClientHelper } from '../helpers/api-client.helper';
import { AppConfig } from '../../shared/config/app-config';
import { LocalStorageService } from './local-storage.service';
import { AggregatorRatingRequest, ConfigResponseModel, CountDown, Survey, SystemNotificationModel, TimeLeftUntil} from '../../shared/models/utility.model';
import { ReplaySubject, Subject } from 'rxjs';
import { KycDashboardData } from '../../shared/models/dashboard.model';
import { AgentStats } from '../../shared/models/device.model';
import { WalletFundingBankAccountData } from '../../shared/models/wallet.model';
import { FormGroup } from '@angular/forms';
import { LegalTermsAndConditionsModalComponent } from '../../lean-shared/components/legal-terms-and-conditions-modal/legal-terms-and-conditions-modal.component';
import { ModalOptionsConfig, ModalService } from '../../lean-shared/components/nz-modal-service/modal.service';
import moment from 'moment';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Injectable({
    providedIn: 'root',
})
export class UtilityService {
    currentUser: any;
    userRole: any;
    userDisplayRole: string;
    countDownExpiredText: string;
    insuranceTermsAndCondition: any;
    promotionText: any;
    accountFundingObj: Subject<WalletFundingBankAccountData> = new ReplaySubject();
    comingSoonDate: string;
    comingSoonTitle: string;
    // tslint:disable-next-line:variable-name
    private _systemNotificationDestroy = new Subject<any>();
    // tslint:disable-next-line:variable-name
    _systemNotificationDestroy$ = this._systemNotificationDestroy.asObservable();
    // tslint:disable-next-line:variable-name
    private _businessUserCategorizationDestroy = new Subject<any>();
    // tslint:disable-next-line:variable-name
    _businessUserCategorizationDestroy$ = this._businessUserCategorizationDestroy.asObservable();
    // tslint:disable-next-line:variable-name
    private _posConfigDestroy = new Subject<any>();
    // tslint:disable-next-line:variable-name
    _posConfigDestroy$ = this._posConfigDestroy.asObservable();
    // tslint:disable-next-line:variable-name
    private _posConfigFeaturesDestroy = new Subject<any>();
    // tslint:disable-next-line:variable-name
    _posConfigFeaturesDestroy$ = this._posConfigFeaturesDestroy.asObservable();
    // tslint:disable-next-line:variable-name
    private _switchContext = new Subject<string>();
    // tslint:disable-next-line:variable-name
    _switchContext$ = this._switchContext.asObservable();
    // tslint:disable-next-line:variable-name
    private _generalModalDestroy = new Subject<any>();
    // tslint:disable-next-line:variable-name
    _generalModalDestroy$ = this._generalModalDestroy.asObservable();
    // tslint:disable-next-line:variable-name
    private _countDown = new Subject<CountDown>();
    // tslint:disable-next-line:variable-name
    _countDown$ = this._countDown.asObservable();
    private systemNotification: SystemNotificationModel;
    private systemNotificationContext: string;
    private aggregatorRatingPost: string;
    private kycDashboardData: KycDashboardData;
    private rolezAccountNo: string;
    private customerAccountName: string;
    private interval: any;
    runningModal: NzModalRef;

    constructor(
        private apiClientHelper: ApiClientHelper,
        public config: AppConfig,
        private localStorage: LocalStorageService,
        public user: AuthorizedUser,
        private modal: ModalService,
    ) {
        this.initialize();
    }

    initialize() {
        this.initializeParameters();
        this.setUserRole();
        this.initializeInsuranceTermsAndCondition();
        this.initializePromotionalText();
        this.initializeRolezAccountNo();
        this.initializeCustomerAccountName();
    }

    initializeParameters() {
        this.systemNotificationContext = this.localStorage.get('systemNotificationContext');
        this.aggregatorRatingPost = this.localStorage.get('aggregatorRatingPost');
        const kyc = this.localStorage.get('kycDashboardData');
        this.kycDashboardData = kyc ? JSON.parse(kyc) : null;
        this.currentUser = this.localStorage.get('currentUser');
    }

    setUserRole() {
        const role = this.user?.roles?.length ? this.user?.roles[0] : null;
        this.userRole = this.localStorage.get(StorageKeys.selected_role) || role;
    }

    initializeInsuranceTermsAndCondition() {
        const insuranceTermsAndCondition = this.localStorage.get('InsuranceTermsAndCondition');
        if (insuranceTermsAndCondition) {
            this.setInsuranceTermsAndCondition(JSON.parse(insuranceTermsAndCondition));
        }
    }

    initializePromotionalText() {
        const promotion = this.localStorage.get('promotionText');
        if (promotion && promotion !== 'undefined') {
            this.setPromotionText(JSON.parse(promotion));
        }
    }

    initializeRolezAccountNo() {
        const rolezAccountNo = this.localStorage.get('rolezAccountNo');
        if (rolezAccountNo) {
            this.setRolezAccountNo(JSON.parse(rolezAccountNo));
        }
    }

    initializeCustomerAccountName() {
        const customerAccountName = this.localStorage.get('customerAccountName');
        if (customerAccountName) {
            this.setCustomerAccountName(customerAccountName);
        }
    }

    destroyGeneralModal(action: ModalActions) {
        this._generalModalDestroy.next(action);
    }

    getDefaultOtpCountDown(): number {
        return this.config.DEFAULT_OTP_COUNT_DOWN;
    }

    setInsuranceTermsAndCondition(termsAndCondition) {
        this.insuranceTermsAndCondition = termsAndCondition;
        this.localStorage.save('InsuranceTermsAndCondition', JSON.stringify(termsAndCondition));
    }

    setRolezAccountNo(accountNo) {
        this.rolezAccountNo = accountNo;
        this.localStorage.save('rolezAccountNo', accountNo);
    }

    setCustomerAccountName(accountName) {
        this.customerAccountName = accountName;
        this.localStorage.save('customerAccountName', accountName);
    }

    getCustomerAccountName() {
        return this.customerAccountName;
    }

    getRolezAccountNo() {
        return this.rolezAccountNo;
    }

    getInsuranceTermsAndCondition() {
        return this.insuranceTermsAndCondition;
    }

    setPromotionText(promotion) {
        this.promotionText = promotion;
        this.localStorage.save('promotionText', JSON.stringify(promotion));
    }

    getPromotionText() {
        return this.promotionText;
    }

    startCountDown(countDownDate: number, hoursOnly: boolean = false) {
        this.interval = setInterval(() => {
            // Get today's date and time
            const now = new Date().getTime();
            // Find the distance between now and the count down date
            const distance = countDownDate - now;
            // Time calculations for days, hours, minutes and seconds
            if (hoursOnly) {
                const days = 0;
                const hours = Math.floor(distance / (1000 * 60 * 60));
                const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((distance % (1000 * 60)) / 1000);
                const countDown = {
                    days,
                    hours,
                    minutes,
                    seconds,
                };
                this._countDown.next(countDown);
            } else {
                const days = Math.floor(distance / (1000 * 60 * 60 * 24));
                const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((distance % (1000 * 60)) / 1000);
                const countDown = {
                    days,
                    hours,
                    minutes,
                    seconds,
                };
                this._countDown.next(countDown);
            }
            if (distance < 0) {
                clearInterval(this.interval);
                this.countDownExpiredText = 'EXPIRED';
            }
        }, 1000);
    }

	getCurrentTimeByMinutes(countDownTime: CountDown, timeInSeconds: number) {
        const second = parseInt(`${countDownTime.seconds}`);
        const minute = parseInt(`${countDownTime.minutes}`);
        const minutesToSeconds = minute * 60;
        return timeInSeconds - (second + minutesToSeconds);
    }

    resetInterval() {
        clearInterval(this.interval);
    }

    startCountDownBasedOnHours(time: number) {
        let hours = 0;
        let minutes = 0;
        let seconds = 0;
        while (true) {
            if (time >= 1000 * 60 * 60) {
                hours++;
                time -= 1000 * 60 * 60;
            } else if (time >= 1000 * 60) {
                minutes++;
                time -= 1000 * 60;
            } else if (time >= 1000) {
                seconds++;
                time -= 1000;
            } else {
                break;
            }
        }
        // Format output
        hours = hours < 10 ? 0 + hours : hours;
        minutes = minutes < 10 ? 0 + minutes : minutes;
        seconds = seconds < 10 ? 0 + seconds : seconds;
        return { hours, minutes, seconds };
    }

    CountdownBasedOnDays(timeDifference: number) {
        const seconds = Math.floor((timeDifference / 1000) % 60);
        const minutes = Math.floor((timeDifference / (1000 * 60)) % 60);
        const hours = Math.floor((timeDifference / (1000 * 60 * 60)) % 24);
        const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
        return {
            days,
            hours,
            minutes,
            seconds,
        };
    }

    removeTime(date: Date) {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    }

    destroySystemNotificationModal(specialAction?) {
        this.localStorage.save('already-notified', '11');
        if (specialAction) {
            this._systemNotificationDestroy.next(specialAction);
        } else {
            this._systemNotificationDestroy.next(true);
        }
    }

    destroyBusinessUserCategorizatioModal(value?) {
        this._businessUserCategorizationDestroy.next(value);
    }

    destroyPOSConfigModal() {
        this._posConfigDestroy.next(true);
    }

    destroyPOSConfigFeaturesModal(value?) {
        this._posConfigFeaturesDestroy.next(value);
    }

    switchContext() {
        const newCurrentUser = this.currentUser === 'agent' ? 'outlet-manager' : 'agent';
        const role = this.currentUser === 'agent' ? UserAlias.agentManager : UserAlias.agent;
        this.localStorage.save('currentUser', newCurrentUser);
        this.localStorage.save('selected_role', role);
    }

    setSystemNotificationContext(context: string) {
        this.systemNotificationContext = context;
        this.localStorage.save('systemNotificationContext', context);
        this._switchContext.next(context);
    }

    setAggregatorRatingPost(post: string) {
        this.aggregatorRatingPost = post;
        this.localStorage.save('aggregatorRatingPost', post);
    }

    getAggregatorRatingPost() {
        return this.aggregatorRatingPost;
    }

    getSystemNotificationContext() {
        return this.systemNotificationContext;
    }

    setAlreadyNotifiedFromLocal() {
        const notice = this.localStorage.get('already-notified');
        return !!notice;
    }

    setSystemNotification(systemNotification: SystemNotificationModel) {
        this.systemNotification = systemNotification;
    }

    getAlreadyNotified() {
        return this.setAlreadyNotifiedFromLocal();
    }

    getNotification() {
        return this.systemNotification;
    }

    getConfig(): Promise<ConfigResponseModel> {
        const url = this.config.MONIEPOINT_HOST + `/api/v1/configurations`;
        return this.apiClientHelper.getForPromise(url);
    }

    getSystemNotification(): Promise<SystemNotificationModel> {
        const url = this.config.MONIEPOINT_HOST + `/api/v1/system-notification`;
        return this.apiClientHelper.getForPromise(url);
    }

    getIdentityVerificationStatus(url: string, payload: any): Promise<any> {
        return this.apiClientHelper.postForPromise(url, payload, false);
    }

    getAPIIdentityVerificationStatus(url: string): Promise<any> {
        return this.apiClientHelper.getForPromise(url, false, false);
    }

    submitRatings(params: AggregatorRatingRequest): Promise<any> {
        const url = this.config.MONIEPOINT_HOST + `/api/v1/aggregator-rating`;
        return this.apiClientHelper.postForPromise(url, params);
    }

    setKycData(kycDashboardData: KycDashboardData) {
        this.kycDashboardData = kycDashboardData;
        this.localStorage.save('kycDashboardData', JSON.stringify(kycDashboardData));
    }

    getKycData() {
        return this.kycDashboardData;
    }

    getAgentStats(): Promise<AgentStats> {
        const url = this.config.MONIEPOINT_HOST + `/api/v1/agents/stats`;
        return this.apiClientHelper.getForPromise(url);
    }

    submitSurvey(params): Promise<any> {
        const url = this.config.MONIEPOINT_HOST + `/api/v1/agent-survey/business`;
        return this.apiClientHelper.postForPromise(url, params);
    }

    getLinkedFundingAccount(): Promise<WalletFundingBankAccountData> {
        const url = `${this.config.MONIEPOINT_HOST}/api/v1/wallets/linked-funding-account`;
        return this.apiClientHelper.getForPromise(url, true);
    }

    validateFormFields(form: FormGroup) {
        for (const i in form.controls) {
            if (form && form.controls) {
                form.controls[i].markAsDirty();
                form.controls[i].updateValueAndValidity();
            }
        }
    }

    getTimeFromDate(time) {
        const currentTime = new Date().getTime();
        const givenTime = time;
        if (currentTime > givenTime) {
            return {
                hours: '00',
                minutes: '00',
                seconds: '00',
            };
        } else {
            const difference = this.getTime(givenTime);
            return {
                hours: difference.hours,
                minutes: difference.minutes,
                seconds: difference.seconds,
            };
        }
    }
    
    timeUntil(futureDate: string | Date): TimeLeftUntil | null {
        const now = new Date();
        const targetDate = new Date(futureDate);
        
        const differenceInMilliseconds = targetDate.getTime() - now.getTime();
        
        if (differenceInMilliseconds <= 0) {
            return
        }
        
        const seconds = Math.floor(differenceInMilliseconds / 1000);
        const minutes = Math.floor(seconds / 60);
        const hours = Math.floor(minutes / 60);
        const daysLeft = Math.floor(hours / 24);
        
        const minutesLeft = minutes % 60;
        const hoursLeft = hours % 24;
        
        return {
            daysLeft,
            hoursLeft,
            minutesLeft
        }
    }

    getTime(givenTime) {
        let diff = givenTime - new Date().getTime();
        const ms = diff % 1000;
        diff = (diff - ms) / 1000;
        const s = diff % 60;
        diff = (diff - s) / 60;
        const m = diff % 60;
        diff = (diff - m) / 60;
        const h = diff;
        const ss = s <= 9 && s >= 0 ? `0${s}` : s;
        const mm = m <= 9 && m >= 0 ? `0${m}` : m;
        const hh = h <= 9 && h >= 0 ? `0${h}` : h;
        return {
            hours: hh,
            minutes: mm,
            seconds: ss,
        };
    }

    countDown(countDownDate) {
        const now = new Date().getTime();
        const timeToComplete = new Date(countDownDate).getTime();
        // Find the distance between now and the count down date
        if (now > timeToComplete) {
            return {
                days: '00',
                hours: '00',
                minutes: '00',
                seconds: '00',
            };
        } else {
            const distance = timeToComplete - now;
            return this.CountdownWithDays(distance);
        }
    }

    CountdownWithDays(timeDifference: number) {
        const seconds = Math.floor((timeDifference / 1000) % 60);
        const minutes = Math.floor((timeDifference / (1000 * 60)) % 60);
        const hours = Math.floor((timeDifference / (1000 * 60 * 60)) % 24);
        const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
        return {
            days: days <= 9 && days >= 0 ? `0${days}` : days,
            hours: hours <= 9 && hours >= 0 ? `0${hours}` : hours,
            minutes: minutes <= 9 && minutes >= 0 ? `0${minutes}` : minutes,
            seconds: seconds <= 9 && seconds >= 0 ? `0${seconds}` : seconds,
        };
    }

    calculateTimimgWithDays(day: number) {
        let months = 0,
            years = 0,
            days = 0,
            weeks = 0;
        while (day) {
            if (day >= 365) {
                years++;
                day -= 365;
            } else if (day >= 30) {
                months++;
                day -= 30;
            } else if (day >= 7) {
                weeks++;
                day -= 7;
            } else {
                days++;
                day--;
            }
        }
        return {
            years: years,
            months: months,
            weeks: weeks,
            days: days,
        };
    }

    launchTCModal() {
        const userRole = this.localStorage.get('selected_role');
        const isShow = this.getTCModalConfig(userRole);
        if (!isShow) {
            return;
        }
        const config = new ModalOptionsConfig();
        config.nzClosable = false;
        config.nzMaskClosable = false;
        config.nzKeyboard = false;
        config.className = DEFAULT_DIALOG_CLASSES;
        config.hideNZTitle = true;
        config.nzComponentParams.callback = () => {
            this.runningModal = null;
        };
        config.nzComponentParams.designType = MONIEPOINT_DESIGN_TYPE.KAMONA;
        config.nzComponentParams.callbackName = 'Close';
        this.runningModal = this.modal.createModal(LegalTermsAndConditionsModalComponent, config);
    }

    getTCModalConfig(userRole) {
        let showTcModal = false;
        switch (userRole) {
            case UserAlias.agent:
            case UserAlias.agentManager:
                showTcModal = this.config.SHOW_TERMS_AND_CONDITIONS_MODAL_BO;
                break;

            case UserAlias.areaManager:
            case UserAlias.aggregator:
                showTcModal = this.config.SHOW_TERMS_AND_CONDITIONS_MODAL_BRM;
                // BRM
                break;

            case UserAlias.supremeAggregator:
                showTcModal = this.config.SHOW_TERMS_AND_CONDITIONS_MODAL_RM;
                // RM
                break;

            case UserAlias.superAggregator:
                showTcModal = this.config.SHOW_TERMS_AND_CONDITIONS_MODAL_SC;
                // SC
                break;
        }

        return showTcModal;
    }

    deepEqual(x, y) {
        const ok = Object.keys;
        const tx = typeof x;
        const ty = typeof y;
        return x && y && tx === 'object' && tx === ty && tx.constructor === ty.constructor
            ? ok(x).length === ok(y).length && ok(x).every((key) => this.deepEqual(x[key], y[key]))
            : x === y;
    }

    checkIfNullish(object: any): boolean {
        return Object.values(object).some((value) => value === null);
    }

    countDownMonths(countDownDate) {
        const now = new Date().getTime();
        const timeToComplete = new Date(countDownDate).getTime();
        // Find the distance between now and the count down date
        if (now > timeToComplete) {
            return {
                days: '00',
                hours: '00',
                minutes: '00',
                seconds: '00',
            };
        } else {
            const distance = timeToComplete - now;
            return this.CountdownWithMonths(distance);
        }
    }

    CountdownWithMonths(timeDifference: number) {
        const duration = moment.duration(timeDifference);

        const monthsLeft = duration.months();
        const daysLeft = duration.days();
        const hoursLeft = duration.hours();
        const minutesLeft = duration.minutes();
        const secondsLeft = duration.seconds();

        return {
            months: monthsLeft,
            days: daysLeft,
            hours: hoursLeft <= 9 && hoursLeft >= 0 ? `0${hoursLeft}` : hoursLeft,
            minutes: minutesLeft <= 9 && minutesLeft >= 0 ? `0${minutesLeft}` : minutesLeft,
            seconds: secondsLeft <= 9 && secondsLeft >= 0 ? `0${secondsLeft}` : secondsLeft,
        };
    }

    getParsedLocalStorageItem<T>(key: string, defaultValue: T): T {
        const storedValue = this.localStorage.get(key);

        if (storedValue) {
            try {
                return JSON.parse(storedValue);
            } catch (error) {
                return defaultValue;
            }
        }

        return defaultValue;
    }

	startMinuteCountDown(durationInMinutes: number) {
        try {
			const duration = durationInMinutes * 60000;
            const currentDate = new Date();
            const futureDate = new Date(currentDate.getTime() + duration);
            let countDownTime = this.getTimeFromDate(futureDate.getTime());
            const countDownInterval = setInterval(() => {
                countDownTime = this.getTimeFromDate(futureDate.getTime());
            }, 1000);
        } catch (err) {
            // do nothing
        }
    }
}

